import React, {useState} from "react";
import Banner from "./Banner/Banner";
import NavLayout from "../../GlobalComponents/NavLayout/NavLayout";
import TokenClaimTable from "./TokenClaimTable/TokenClaimTable";
import { common, privateNav } from "../../utils/navItems";
import Footer from "../../GlobalComponents/Footer/Footer";
import ConnectButton from "../../GlobalComponents/ConnectButton/ConnectButton";

const Claims = () => {
  const [address, setAddress] = useState("");
  return (
    <div>
      <NavLayout
        navItems={privateNav}
        setAddress={setAddress}
        buttons={
          <div className="button-container">
            <ConnectButton></ConnectButton>
          </div>
        }
      ></NavLayout>
      <Banner></Banner>
      <TokenClaimTable></TokenClaimTable>
      <div className="mt-10">
        <Footer></Footer>
      </div>
    </div>
  );
};

export default Claims;
